import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';

@Component({
  selector: 'app-_202_SpecialEducationStudentsDisabilitiesRpt',
  templateUrl: './_202_SpecialEducationStudentsDisabilitiesRpt.component.html',
  styleUrls: ['./_202_SpecialEducationStudentsDisabilitiesRpt.component.css']
})
export class _202_SpecialEducationStudentsDisabilitiesRptComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; //datepicker
  selectedPAU: SelectItem; selectedSite: SelectItem; selectedDivision: SelectItem; //dropdown   
  _PAUid: string = null; _siteId: string = null; _divisionId: string = null;
  public showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- All PAUs --", shortText: null, updatedOn: null }];
  lookupDivisionList: ILookupBase[] = [{ value: null, label: "-- NO DIVISIONS TO VIEW ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- All PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }

        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Division lookup
              let params = {} as IStudentSearchParameters;
              params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
              params.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupDivision(this._baseUrl + 'api/Lookup/GetDivisionList/', params)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupDivisionList = [{ value: null, label: "-- NO DIVISIONS TO VIEW ! --", shortText: null, updatedOn: null }]
                  }
                  else {
                    this.lookupDivisionList = [{ value: null, label: "-- All Divisions --", shortText: null, updatedOn: null }].concat(res);
                    this.selectedDivision = this.lookupDivisionList[4];
                  }
                },
                  err => console.error(err)
                );

            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = (id.value != null ? id.value : '');
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
        }
      },
        err => console.error(err)
      );
  }

  setSite(id): void {
    this._siteId = id.value;
  }

  setDivision(id): void {
    this._divisionId = id.value;
  }
  getSiteIdList(): string {
    let siteIdList: string;
    this.lookupSiteList.forEach((site, index, arr) => {
      if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW ! --")) {
        if (site.label != "-- All Sites --") siteIdList += site.value + '^';
      }
    });
    return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
  }

  getDivisionIdList(): string {
    let divisionIdList: string;
    this.lookupDivisionList.forEach((division, index, arr) => {
      if ((division.label != null) && (division.label != "-- NO DIVISIONS TO VIEW --")) {
        if (division.label != "-- All Divisions --") divisionIdList += division.value + '^';
      }
    });
    return divisionIdList.slice(0, divisionIdList.length - 1).replace('undefined', '');
  }

  viewReport() {
    this.showSpinner = true;
    let reportParamArray: IReportParameter[] = [];
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    var selectedDivisionName = this.lookupDivisionList.find(z => z.value === this._divisionId).label;
    var selectedDivisionId = this.lookupDivisionList.find(z => z.value === this._divisionId).value;

    reportParamArray.push(
      { parameterName: 'PAU', parameterValue: (this.selectedPAU != null && selectedPAUValue != '-- All PAUs --') ? selectedPAUValue : '' },
      { parameterName: 'SITE', parameterValue: (this.selectedSite != null && selectedSiteValue != "-- All Sites --") ? selectedSiteValue  : '' },
      //{ parameterName: 'SiteIdList', parameterValue: (this.selectedPAU != null && selectedPAUValue != "-- All PAUs --") ? this.getSiteIdList().replace('undefined', '') : '' },
      { parameterName: 'DIVName', parameterValue: (this.selectedDivision != null && selectedDivisionName != '-- All Divisions --') ? selectedDivisionName.replace('-- ', '').replace(' --', '') : 'All Divisions' },
      { parameterName: 'DIVID', parameterValue: selectedDivisionId != null ? selectedDivisionId : this.getDivisionIdList() /*''*/ },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' }
    );

    let now = new Date();
    let localReportFileName = '202-SpecialEducationStudentsDisabilities_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "JCS_Special_Education_Detail";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
